import { ButtonHTMLAttributes } from "react";

interface TextButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
}
export const TextButton: React.FC<TextButtonProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    
    <button
      type="button"
      className={`flex items-center justify-center text-green-f underline hover:text-green-d duration-300 ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};
